import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import OrderDetails from '../../pages/OrderDetails';

interface IOrderDetailsDialogProps {
  open: boolean;
  onClose: () => void;
}

export const OrderDetailsDialog = (props: IOrderDetailsDialogProps) => {
  return ( 
    <Dialog onClose={() => {props.onClose()}} aria-labelledby="order-details-dialog-title" open={props.open}>
      <DialogContent>
        <OrderDetails />
      </DialogContent>
    </Dialog>
  );
}
